import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "transcript-viewer" }
const _hoisted_2 = {
  key: 0,
  class: "transcript-state"
}
const _hoisted_3 = {
  key: 1,
  class: "transcript-state transcript-error-state"
}
const _hoisted_4 = { class: "error-message" }
const _hoisted_5 = {
  key: 2,
  class: "transcript-empty"
}
const _hoisted_6 = {
  key: 3,
  class: "transcript-messages"
}
const _hoisted_7 = { class: "role-label" }
const _hoisted_8 = { class: "message-text" }

import { LoadingBars } from "@/components/ui";
import { useTranscriptQuery } from "@/composables/ui/useTranscriptQuery";
import { parseTranscript } from "@/utils/callRoles";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TranscriptViewer',
  props: {
    transcriptText: { default: "" },
    transcriptUrl: { default: null }
  },
  emits: ["refresh"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const transcriptUrlRef = computed(() => props.transcriptUrl ?? null);

const { data: fetchedText, isLoading, error, refetch } = useTranscriptQuery(transcriptUrlRef);

// expired presigned URL → parent must re-fetch the CallLog to mint a new one
const isExpiredError = computed(() => {
  const e = error.value;
  return e instanceof Error && /expired/i.test(e.message);
});

function handleRetry() {
  if (isExpiredError.value) {
    emit("refresh");
  } else {
    refetch();
  }
}

const errorMessage = computed(() => {
  if (!error.value) return "";
  if (error.value instanceof Error) return error.value.message;
  return String(error.value);
});

const effectiveText = computed(() => {
  if (props.transcriptUrl) {
    return fetchedText.value ?? "";
  }
  return props.transcriptText ?? "";
});

const parsedTranscript = computed(() => {
  const text = effectiveText.value;
  if (!text) return [];
  return parseTranscript(text);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.transcriptUrl && _unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(LoadingBars), {
            size: "sm",
            text: "Loading transcript..."
          })
        ]))
      : (__props.transcriptUrl && _unref(error))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(errorMessage.value), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-sm",
              onClick: handleRetry
            }, "Retry")
          ]))
        : (parsedTranscript.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("p", null, "No transcript content available.", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parsedTranscript.value, (segment, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["transcript-message", segment.role.toLowerCase().replace(' ', '-')])
                }, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(segment.role) + ":", 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(segment.text), 1)
                ], 2))
              }), 128))
            ]))
  ]))
}
}

})